// extracted by mini-css-extract-plugin
export default {"appBackground":"App_appBackground__sjJmP","darkThemeBackground":"App_darkThemeBackground__nDd3x","lightThemeBackground":"App_lightThemeBackground__9ri+E"};